import VueRouter from 'vue-router';

import splashAccepted from '../src/middleware/splashAccepted';
import membershipCheck from '../src/middleware/membershipCheck';
import advertisingStore from '../src/middleware/advertisingStore';
import streamingServer from "../src/middleware/streamingServer";

import Home from './views/Home2021';
import PageNotFound from './views/PageNotFound';
import AboutDivas from './views/AboutDivas';
import VideoWatch from './views/VideoWatch';
import VideoIndex from './views/VideoIndex';
import VideoHotspot from './views/VideoHotspot';
import CategoryIndex from './views/CategoryIndex';
import ModelIndex from './views/ModelIndex';
import WebstarsIndex from './views/WebstarsIndex';
import ModelProfile from './views/V2/ModelProfile';
import FrequentlyAskedQuestions from './views/FrequentlyAskedQuestions.vue';
import Dashboard from './views/Dashboard';
import Membership from './views/Membership';
import LoginRegister from './views/LoginRegister';
import Splash from './views/Splash';
import RecoverPassword from './views/RecoverPassword';
import ConfirmEmail from './views/ConfirmEmail';
import PaymentResult from './views/PaymentResult';
import SignedOut from './views/SignedOut';
import Subscribe from './views/Subscribe';
import FinishRegistration from "./views/FinishRegistration";
import Casting from "./views/Casting";
import PaymentResultCcbill from "./views/PaymentResultCcbill";
import SingUp from "./views/SingUp";

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({x: 0, y: 0}),
    routes: [
        { name: 'splash',         path: '/',                   component: Splash,         meta: {splash: false} },
        { name: 'home',           path: '/home',               component: Home },

        { name: 'dashboard',      path: '/dashboard',          component: Dashboard,      meta: {auth: true} },
        { name: 'membership',     path: '/membership',         component: Membership,     meta: {auth: true} },

        { name: 'payment.result', path: '/payment_result/',    component: PaymentResult}, //Tiene un redirect especial este componente en mounted
        { name: 'payment.result.ccbill', path: '/payment_result_ccbill/',    component: PaymentResultCcbill}, //Tiene un redirect especial este componente en mounted

        { name: 'singup',         path: '/singup',             component: SingUp,         meta: {auth: false} },
        { name: 'login',          path: '/login',              component: LoginRegister,  meta: {auth: false} },
        { name: 'subscribe',      path: '/subscribe',          component: Subscribe,      meta: {membership: false} },

        { name: 'video.search',   path: '/videos/search',      component: VideoIndex },
        { name: 'video.index',    path: '/videos',             component: VideoIndex },
        { name: 'video.hotspot',  path: '/videos/hot',         component: VideoHotspot },
        { name: 'video.watch',    path: '/videos/:id/watch',   component: VideoWatch },

        { name: 'category.index', path: '/categories',         component: CategoryIndex },

        { name: 'model.index',    path: '/models/',            component: ModelIndex },
        { name: 'model.profile',  path: '/models/:id/profile', component: ModelProfile },

        { name: 'webstars.index', path: '/webstars/',          component: WebstarsIndex },

        { name: 'about',          path: '/about/',             component: AboutDivas },

        { name: 'faqs',           path: '/faqs/',              component: FrequentlyAskedQuestions },

        { name: 'user.recover',   path: '/recover/',           component: RecoverPassword, meta: {auth: false} },
        { name: 'user.finish',    path: '/finish/',            component: FinishRegistration, meta: {auth: false}},
        { name: 'user.confirm',   path: '/verify/',            component: ConfirmEmail,    meta: {auth: null} },

        { name: 'error404',       path: '*',                   component: PageNotFound },

        { name: 'signedout',      path: '/signedout/',         component: SignedOut },

        { name: 'casting',   path: '/casting/',                component: Casting, meta: {auth: false} },

        // warning: al ser un parámetro en root, dejar esto abajo para no romper las otras rutas
        { name: 'model.username', path: '/:username',         component: ModelProfile },
        { name: 'model.username.profile',  path: '/models/:username', component: ModelProfile },
    ]
});

/* Splash middleware con redirect para stats */
router.beforeEach(advertisingStore);
router.beforeEach(splashAccepted);
/* Splash middleware con redirect para stats */
router.beforeEach(streamingServer);

/* Membership middleware */
router.afterEach(membershipCheck);
/* Membership middleware */

export default router;